import ScenarioActionType from '@/store/modules/scenario/scenario.type'
import { VariableService } from '@/services/bot.service'

const types = ScenarioActionType

export const VariableStoreMutation = {
    [types.VARIABLE_LIST]: (state, payload) => {
        state.variableList = payload
    }
}

export const VariableStoreAction = {
    [types.LOAD_VARIABLE] (context) {
        return VariableService.search(
            context.rootState.bot.code,
            context.state.defaultScenarioCode
        ).then(result => {
            context.commit(types.VARIABLE_LIST, result.data.sort((a, b) => a.name.localeCompare(b.name)))
        })
    },
    [types.CREATE_VARIABLE] (context, data) {
        context.commit(types.ADD_SAVING_COUNT, 1)
        return VariableService.create(
            context.rootState.bot.code,
            context.state.defaultScenarioCode,
            data
        ).then(result => {
            context.state.variableList.push(result.data)
            return result.data
        })
    },
    [types.UPDATE_VARIABLE] (context, data) {
        context.commit(types.ADD_SAVING_COUNT, 1)
        return VariableService.update(
            context.rootState.bot.code,
            context.state.defaultScenarioCode,
            data.id,
            data
        ).then(result => {
            let variable = result.data
            let variableList = context.state.variableList
            for (let i = 0; i < variableList.length; i++) {
                if (variableList[i].id === variable.id) {
                    variableList[i] = variable
                    break
                }
            }
            return variable
        }).finally(() => {
            context.commit(types.ADD_SAVING_COUNT, -1)
        })
    },
    [types.DELETE_VARIABLE] (context, item) {
        context.commit(types.ADD_SAVING_COUNT, 1)
        return VariableService.delete(
            context.rootState.bot.code,
            context.state.defaultScenarioCode,
            item.id
        ).then(() => {
            let variableList = context.state.variableList
            for (let i = 0; i < variableList.length; i++) {
                if (variableList[i].id === item.id) {
                    variableList.splice(i, 1)
                    break
                }
            }
        }).finally(() => {
            context.commit(types.ADD_SAVING_COUNT, -1)
        })
    }
}
